
import React, { useState } from "react";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import Utility from "../../../utility/Utility";
import ReportService from "../../../services/report-service/ReportService";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

function Spendings() {
  const [fullName, setFullName] = useState<string>("");

  const getInitialDate = (days: number) => {
    const newDt = new Date();
    newDt.setDate(newDt.getDate() + days);
    return moment(newDt).format("YYYY-MM-DD");
  };

  const [selectedToDate, setSelectedToDate] = React.useState(getInitialDate(0));
  const [selectedFromDate, setSelectedFromDate] = React.useState(getInitialDate(-30));
  const [maxDate, setMaxToDate] = React.useState(getInitialDate(0));
  const [validationMessage, setvalidationMessage] = React.useState("");
  const [isValidate, setIsValidate] = React.useState(false);
  const classes = useStyles();
  const [reportData, setReportData] = useState("");
  const [pdfBytes, setpdfBytes] = useState("");
  const [showDownloadBtn, setShowDownloadBtn] = useState(false);

  const [selectedType, SetSelectedType] = useState<"all" | "call" | "message">("all");

  const handleFromDateChange = (date: any) => {
    setSelectedFromDate(date.target.value);
  };

  const handleFullNameChange = (name: any) => {
    setFullName(name.target.value);
  };

  const handleToDateChange = (date: any) => {
    setSelectedToDate(date.target.value);
  };

  const CurrentDate = () => {
    const currDate = new Date();
    return new Date(currDate.getFullYear(), currDate.getMonth(), currDate.getDate());
  };

  const parseDate = (dt: Date) => {
    return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
  };

  const getDateFromString = (date: string) => {
    return new Date(date);
  };

  const ClearSearchCriteria = () => {
    setSelectedToDate(getInitialDate(0));
    setFullName("");
    setSelectedFromDate(getInitialDate(-30));
    SetSelectedType("all");
  };

  const Download = () => {
    const blob = Utility.b64toBlob(pdfBytes);
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Transaction Spendings";
    a.click();
    URL.revokeObjectURL(url);
  };

  const getReport = () => {
    // Your original validation logic duplicated date > CurrentDate; keeping same behavior
    if (
      parseDate(getDateFromString(selectedFromDate)) > CurrentDate() ||
      parseDate(getDateFromString(selectedToDate)) > CurrentDate()
    ) {
      setIsValidate(true);
      setvalidationMessage("From Date cannot be greater than To Date");
      return;
    }

    if (
      parseDate(getDateFromString(selectedFromDate)) > CurrentDate() ||
      parseDate(getDateFromString(selectedToDate)) > CurrentDate()
    ) {
      setIsValidate(true);
      setvalidationMessage("From Date and To Date cannot be in future");
      return;
    }

    setIsValidate(false);
    setvalidationMessage("");

    const frmDate = selectedFromDate;
    const toDate = moment(selectedToDate + " " + "23:59:59").format("MM/DD/YYYY hh:mm:ss A");

    ReportService.GetSpendingDetailReport(
      frmDate === "Invalid date" ? "0001-01-01" : frmDate,
      toDate === "Invalid date" ? "0001-01-01" : toDate,
      fullName,
      selectedType
      // If needed, you can also pass `status` to filter server-side
    ).then((res: any) => {
      setReportData(res.data.result.reportHTML);
      setpdfBytes(res.data.result.reportBytes);
      setShowDownloadBtn(true);
    });
  };

  return (
    <div className="col-10 mt-4">
      <h3>Spendings</h3>
      <div className="pt-2">
        <form className={classes.container} noValidate>
          <label className="m-3 ">Name :</label>
          <input
            className="form-control m-3 form-control-sm"
            type="name"
            name="txtfullName"
            value={fullName}
            onChange={handleFullNameChange}
            style={{ backgroundColor: "#fff", width: "185px" }}
            placeholder="Name"
          />

          <TextField
            id="dateFrom"
            label="From Date"
            type="date"
            value={selectedFromDate}
            onChange={handleFromDateChange}
            InputProps={{ inputProps: { max: selectedToDate } }}
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
          />

          <TextField
            id="dateTo"
            label="To Date"
            type="date"
            value={selectedToDate}
            onChange={handleToDateChange}
            InputProps={{ inputProps: { max: maxDate } }}
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
          />

          {/* Force radio buttons to start from a NEW LINE */}
          <div className="w-100"></div>

          <div className="form-group mb-2">
            <div className="p-2">
              <div className="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  value="all"
                  id="all"
                  name="status"
                  className="custom-control-input"
                  checked={selectedType === "all"}
                  onChange={(e) => SetSelectedType(e.target.value as "all" | "call" | "message")}
                />
                <label className="custom-control-label" htmlFor="all">
                  All
                </label>
              </div>

              <div className="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  value="call"
                  id="calls"
                  name="status"
                  className="custom-control-input"
                  checked={selectedType === "call"}
                  onChange={(e) => SetSelectedType(e.target.value as "all" | "call" | "message")}
                />
                <label className="custom-control-label" htmlFor="calls">
                  Calls
                </label>
              </div>

              <div className="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  value="message"
                  id="messages"
                  name="status"
                  className="custom-control-input"
                  checked={selectedType === "message"}
                  onChange={(e) => SetSelectedType(e.target.value as "all" | "call" | "message")}
                />
                <label className="custom-control-label" htmlFor="messages">
                  Messages
                </label>
              </div>
            </div>
          </div>

          <div className="custom-control custom-radio custom-control-inline">
            <button
              color="secondary"
              onClick={ClearSearchCriteria}
              type="button"
              className="btn btn-sm  float-right search-btn stnd-btn view-r-btn"
            >
              Reset
            </button>
            <button
              color="secondary"
              onClick={getReport}
              type="button"
              className="btn btn-sm  float-right search-btn stnd-btn view-r-btn"
            >
              View Report
            </button>
            {isValidate && (
              <span className="error-msg" style={{ color: "#ff0000" }}>
                {validationMessage}
              </span>
            )}
          </div>
        </form>

        <div className="mt-4">
          <div className="mb-0 heading">
            <h5>
              Report{" "}
              {showDownloadBtn ? (
                <button
                  color="secondary"
                  onClick={Download}
                  type="button"
                  className="btn btn-sm btn-outline-secondary float-right"
                >
                  Save as
                </button>
              ) : (
                ""
              )}
            </h5>
          </div>
          <div className="report-view-bx">
            <div dangerouslySetInnerHTML={{ __html: reportData }} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Spendings;
